module.exports = __webpack_public_path__ + "static/assets/93db39f338237e6a51790829ba22a879.png";